import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const OPPORTUNITY_IMAGE = 'https://cdn.magicpatterns.com/uploads/vdx8712JyPb4gTFjQiTyfL/dESCUBRI_COMO_ARMARLO_EN_CASA_EN_48_HS_EXPERIENCIA.webp';
export function OpportunitySection() {
  return <section className="bg-white pt-0 mt-0 pb-16" data-id="element-199">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-201">
          <span className="text-2xl md:text-3xl font-extrabold uppercase text-[#2D5A27] font-sans" data-id="element-202">
            APROVECHA ESTA NUEVA TENDENCIA DE ORIGEN TAIWANÉS
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-203">
          <img src={OPPORTUNITY_IMAGE} alt="Oportunidad Bubble Tea" width={1200} height={800} loading="lazy" decoding="async" className="w-full h-auto block mx-auto" data-id="element-204" />
        </motion.div>
      </div>
    </section>;
}